import React, { useState } from 'react';
import { Youtube, FileText, Save, Eye } from 'lucide-react';
import axios from 'axios';
import '../css/Video.css';

const Video = () => {
  const [formData, setFormData] = useState({
    title: '',
    youtubeUrl: '',
   
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [vide, setVid] = useState([]);

  const getYouTubeThumbnail = (url) => {
    console.log('entered thumbnail');
  const videoIdMatch = url.match(/(?:v=|\/embed\/|\.be\/)([a-zA-Z0-9_-]{11})/);
  const videoId = videoIdMatch ? videoIdMatch[1] : null;
  if (!videoId) return null;
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
};


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'videoUrl') {
    //const thumbnailUrl = getYouTubeThumbnail(value);
    //console.log('thumbnaiUrl', thumbnailUrl);
    setFormData((prev) => ({
      ...prev,
      youtubeUrl: value,
     
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  }
  };

  const extractYoutubeId = (url) => {
    const match = url.match(/[?&]v=([^&#]*)/) || url.match(/youtu\.be\/(.*)/);
    return match ? match[1] : null;
  };

  const handleSubmit = async (e) => {
    console.log('submit clicked');
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const res = await axios.post('/api/videos', formData);
      setVid(res.data);
      alert('Video added successfully!');
      setFormData({ title: '', youtubeUrl: '', thumbnailUrl: '' });
      setShowPreview(false);
    } catch (error) {
      console.error('Error submitting video:', error);
    }
    setIsSubmitting(false);
  };

  const isFormValid = formData.title.trim() && extractYoutubeId(formData.youtubeUrl);
  const youtubeId = extractYoutubeId(formData.youtubeUrl);

  return (
    <div className='vidcontainer'>
      <div className='vidwrapper'>
        <div className='vidcard'>
          <div className='vidheader'>
            <h1 className='vidheaderTitle'><FileText size={30} /> Add Video to Gallery</h1>
            <p className='vidheaderSubtext'>Add videos to your video gallery using a YouTube URL</p>
          </div>

          <div className='vidcontent'>
            <div>
              <label className='vidlabel'>Video Title *</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={(e) => handleInputChange(e)}
                placeholder="Enter video title"
                //style={styles.input}
                className='vidinput'
              />
            </div>

            <div>
              <label className='vidlabel'><Youtube size={16} /> YouTube URL *</label>
              <input
                type="url"
                name="youtubeUrl"
                value={formData.youtubeUrl}
                onChange={(e) => handleInputChange(e)}
                placeholder="https://www.youtube.com/watch?v=xyz"
                //style={styles.input}
                className='vidinput'
              />
            </div>

            <div>
              <button
                onClick={() => setShowPreview(!showPreview)}
                style={{
                  //...styles.toggleBtn,
                  opacity: isFormValid ? 1 : 0.5,
                  cursor: isFormValid ? 'pointer' : 'not-allowed'
                }}
                className='vidtoggleBtn'
                disabled={!isFormValid}
              >
                <Eye size={16} style={{ marginRight: 6 }} />
                {showPreview ? 'Hide Preview' : 'Show Preview'}
              </button>
            </div>

            {showPreview && youtubeId && (
              <div className='vidpreviewBox'>
                <h3 className='vidpreviewHeading'>Preview</h3>
                <div className='vidpreviewCard'>
                  <h2 className='vidpreviewTitle'>{formData.title}</h2>
                  <iframe
                    width="100%"
                    height="315"
                    src={`https://www.youtube.com/embed/${youtubeId}`}
                    title="YouTube video preview"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    //style={styles.previewIframe}
                    className='vidpeviewIframe'
                  />
                </div>
              </div>
            )}

            <div className='vidsubmitBox'>
              <button
                onClick={handleSubmit}
                disabled={!isFormValid || isSubmitting}
                style={{
                  //...styles.submitBtn,
                  background: isFormValid && !isSubmitting
                    ? 'linear-gradient(to right, #2563eb, #7c3aed)'
                    : '#aaa',
                  cursor: !isFormValid || isSubmitting ? 'not-allowed' : 'pointer'
                }}
                className='vidsubmitBtn'
              >
                {isSubmitting ? 'Submitting...' : <><Save size={20} /> Add Video</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { padding: '2rem', backgroundColor: '#f9fafb' },
  wrapper: { maxWidth: '720px', margin: 'auto' },
  card: { backgroundColor: '#fff', borderRadius: '1rem', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' },
  header: { background: 'linear-gradient(to right, #2563eb, #7c3aed)', padding: '2rem', color: '#fff' },
  headerTitle: { fontSize: '1.75rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '0.75rem' },
  headerSubtext: { color: '#c7d2fe', marginTop: '0.5rem' },
  content: { padding: '2rem', display: 'flex', flexDirection: 'column', gap: '2rem' },
  label: { fontWeight: '600', marginBottom: '0.5rem', display: 'block' },
  input: { width: '100%', padding: '0.75rem', borderRadius: '0.5rem', border: '2px solid #e5e7eb', fontSize: '1rem' },
  toggleBtn: { padding: '0.5rem 1rem', backgroundColor: '#eee', border: 'none', borderRadius: '0.5rem', display: 'flex', alignItems: 'center', fontWeight: '500' },
  previewBox: { padding: '1.5rem', borderRadius: '0.75rem', backgroundColor: '#f3f4f6', border: '2px solid #ddd' },
  previewHeading: { fontSize: '1.1rem', fontWeight: '600', marginBottom: '1rem' },
  previewCard: { backgroundColor: '#fff', padding: '1rem', borderRadius: '0.75rem' },
  previewTitle: { fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' },
  previewIframe: { borderRadius: '0.5rem' },
  submitBox: { display: 'flex', justifyContent: 'flex-end' },
  submitBtn: { display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.75rem 1.5rem', fontSize: '1rem', color: '#fff', border: 'none', borderRadius: '0.5rem', fontWeight: '600' }
};

export default Video;
